import { DatePicker } from 'antd'
import { useEffect, useState } from 'react'
import BaseEditingAttributesCell from './BaseEditingAttributesCell'
import moment from 'moment'

{ isMoment } = moment

EditingDateCell = ({ defaultValue, r, c }) ->

  [value, setValue] = useState(defaultValue)

  useEffect( ->
    setValue(defaultValue)
    undefined
  , [defaultValue])

  parseValue = ->
    if  _.isEmpty(value)
      ''
    else if isMoment(value)
      value
    else
      moment(value)

  <BaseEditingAttributesCell
    value={parseValue()}
    immediatelyWrite={true}
    initialValue={defaultValue}
    r={r}
    c={c}
  >
    <DatePicker
      value={parseValue()}
      size="small"
      onChange={(val) -> setValue(val)}
    />
  </BaseEditingAttributesCell>

export default EditingDateCell
